// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CEbp","selected":"styles_selected__2aTrS"};